import React, { useEffect, useState } from "react";
import api from "../../api/api";

export default function RiderHome() {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    loadOrders();
  }, []);

  const loadOrders = async () => {
    const res = await api.get("/api/riders/orders");
    const data = Array.isArray(res.data)
      ? res.data
      : res.data.orders || [];
    setOrders(data);
  };

  const acceptOrder = async (id) => {
    await api.post(`/api/rider/orders/${id}/accept`);
    loadOrders();
  };

  const markDelivered = async (id) => {
    await api.post(`/api/rider/orders/${id}/deliver`);
    loadOrders();
  };

  return (
    <div>
      <h2>Assigned Orders</h2>

      {orders.length === 0 && <p>No assigned orders.</p>}

      {orders.map((o) => (
        <div
          key={o._id}
          style={{
            padding: 10,
            border: "1px solid #ccc",
            margin: "8px 0",
          }}
        >
          <p>
            <b>Order:</b> {o._id}
          </p>
          <p>
            <b>Total:</b> Ksh {o.total}
          </p>
          <p>
            <b>Status:</b> {o.status}
          </p>

          {o.status === "paid" && (
            <button onClick={() => acceptOrder(o._id)}>Accept</button>
          )}

          {o.status === "shipped" && (
            <button onClick={() => markDelivered(o._id)}>
              Mark Delivered
            </button>
          )}
        </div>
      ))}
    </div>
  );
}
